var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { LibIcon } from './components';
var CustomServices = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.size, size = _c === void 0 ? 44 : _c, props = __rest(_a, ["title", "size"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: 1.34 * size, height: size, viewBox: "0 0 59 44", fill: "none" }, props),
        title && React.createElement("title", null, title),
        React.createElement("rect", { x: "5", width: "48", height: "40.1013", rx: "5", fill: "#1E70DD" }),
        React.createElement("rect", { y: "40", width: "59", height: "4", rx: "1", fill: "#1E70DD" }),
        React.createElement("rect", { x: "8", y: "3", width: "42", height: "34", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M33.551 15.7422C33.551 18.2272 31.5382 20.2399 29.0532 20.2399C26.5682 20.2399 24.5554 18.2272 24.5554 15.7422C24.5554 13.2571 26.5682 11.2444 29.0532 11.2444C31.5382 11.2444 33.551 13.2571 33.551 15.7422ZM20.0576 26.9866C20.0576 23.9956 26.0509 22.4888 29.0532 22.4888C32.0554 22.4888 38.0487 23.9956 38.0487 26.9866V29.2355H20.0576V26.9866Z", fill: "#1E70DD" })));
};
export var CustomServicesIcon = function (props) { return (React.createElement(LibIcon, __assign({ icon: CustomServices }, props))); };
//# sourceMappingURL=CustomServicesIcon.js.map